import { heroStats, heroTags } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20background%2C%20soft%20bokeh%20light%20orbs%20over%20a%20cozy%20blurred%20cafe%20crowd%2C%20gentle%20coral%20amber%20and%20cream%20gradient%20wash%2C%20crumpled%20paper%20texture%2C%20artistic%20stylized%20cinematic%20depth%20of%20field%2C%20high%20detail%20harmonious%20warm%20composition%2C%20no%20text&width=1600&height=900&seq=melonsite-hero-01&orientation=landscape"
          alt="骚女qq话题汇总站的暖色调氛围背景"
          title="骚女qq 传闻爆料瓜田 话题热议 氛围背景"
          className="h-full w-full object-cover object-top opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/30" />
      </div>

      <div className="relative mx-auto w-full max-w-[1200px] px-4 pb-12 pt-14 md:px-6 md:pb-16 md:pt-20 lg:pb-20 lg:pt-24">
        <div className="max-w-3xl">
          <span className="anim-fade-up inline-flex items-center gap-2 rounded-full border border-accent-300/70 bg-accent-50/80 px-4 py-1.5 text-xs font-semibold tracking-wide text-accent-800">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500 anim-pulse-dot" />
            网络热议 · 传闻盘点 · 吃瓜集合
          </span>

          <h1 className="anim-fade-up delay-100 mt-6 font-heading text-3xl font-black leading-[1.22] text-foreground-950 md:text-5xl md:leading-[1.18]">
            骚女qq 传闻爆料瓜田，
            <br className="hidden sm:block" />
            话题热议事件一次看全
          </h1>

          <p className="anim-fade-up delay-200 mt-6 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base md:leading-8">
            从最初的零散提问，到如今冲上讨论区前列，我们把与
            <strong className="font-semibold text-foreground-900">骚女qq</strong>
            相关的传闻、话题与爆料重新梳理成时间线。截图真假各有说法，澄清与质疑同时存在——
            先看整理，再自己判断，理性吃瓜才是长久之计。
          </p>

          <div className="anim-fade-up delay-300 mt-7 flex flex-wrap gap-2.5">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="cursor-pointer rounded-full border border-background-200 bg-background-50/90 px-3.5 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                # {tag}
              </span>
            ))}
          </div>

          <div className="anim-fade-up delay-400 mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" />
              直奔今日热议榜
            </a>
            <a
              href="#discuss"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-chat-smile-2-line text-base" />
              看网友怎么说
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 border-t border-background-300/60 pt-8 md:mt-16 md:grid-cols-4 md:gap-5">
          {heroStats.map((stat) => (
            <div key={stat.label} className="border-l-2 border-accent-300 pl-4">
              <p className="font-display text-2xl font-black leading-none text-foreground-950 md:text-4xl">
                {stat.value}
                <span className="ml-1 text-sm font-semibold text-primary-500 md:text-base">
                  {stat.unit}
                </span>
              </p>
              <p className="mt-2 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}